import React from 'react';

const DateRange = () => {
  return (
    <div className="mt-8">
      <div className="flex flex-column justify-items-center gap-5 n:flex-row n:gap-12 md:gap-18">
        <div className="govuk-form-group">
          <fieldset
            className="govuk-fieldset"
            role="group"
            aria-describedby="passport-issued-hint"
          >
            <h3 className="govuk-heading-s chart-title">Start date</h3>
            <div id="passport-issued-hint" className="govuk-hint">
              For example, 27 3 2019
            </div>
            <div className="govuk-date-input" id="passport-issued">
              <div className="govuk-date-input__item">
                <div className="govuk-form-group">
                  <label
                    className="govuk-label govuk-date-input__label"
                    htmlFor="passport-issued-day"
                  >
                    Day
                  </label>
                  <input
                    className="govuk-input govuk-date-input__input govuk-input--width-2"
                    id="passport-issued-day"
                    name="passport-issued-day"
                    type="text"
                    inputMode="numeric"
                  />
                </div>
              </div>
              <div className="govuk-date-input__item">
                <div className="govuk-form-group">
                  <label
                    className="govuk-label govuk-date-input__label"
                    htmlFor="passport-issued-month"
                  >
                    Month
                  </label>
                  <input
                    className="govuk-input govuk-date-input__input govuk-input--width-2"
                    id="passport-issued-month"
                    name="passport-issued-month"
                    type="text"
                    inputMode="numeric"
                  />
                </div>
              </div>
              <div className="govuk-date-input__item">
                <div className="govuk-form-group">
                  <label
                    className="govuk-label govuk-date-input__label"
                    htmlFor="passport-issued-year"
                  >
                    Year
                  </label>
                  <input
                    className="govuk-input govuk-date-input__input govuk-input--width-4"
                    id="passport-issued-year"
                    name="passport-issued-year"
                    type="text"
                    inputMode="numeric"
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="govuk-form-group">
          <fieldset
            className="govuk-fieldset"
            role="group"
            aria-describedby="passport-issued-hint"
          >
            <h3 className="govuk-heading-s chart-title">End date</h3>

            <div id="passport-issued-hint" className="govuk-hint">
              For example, 15 5 2024
            </div>
            <div className="govuk-date-input" id="passport-issued">
              <div className="govuk-date-input__item">
                <div className="govuk-form-group">
                  <label
                    className="govuk-label govuk-date-input__label"
                    htmlFor="passport-issued-day"
                  >
                    Day
                  </label>
                  <input
                    className="govuk-input govuk-date-input__input govuk-input--width-2"
                    id="passport-issued-day"
                    name="passport-issued-day"
                    type="text"
                    inputMode="numeric"
                  />
                </div>
              </div>
              <div className="govuk-date-input__item">
                <div className="govuk-form-group">
                  <label
                    className="govuk-label govuk-date-input__label"
                    htmlFor="passport-issued-month"
                  >
                    Month
                  </label>
                  <input
                    className="govuk-input govuk-date-input__input govuk-input--width-2"
                    id="passport-issued-month"
                    name="passport-issued-month"
                    type="text"
                    inputMode="numeric"
                  />
                </div>
              </div>
              <div className="govuk-date-input__item">
                <div className="govuk-form-group">
                  <label
                    className="govuk-label govuk-date-input__label"
                    htmlFor="passport-issued-year"
                  >
                    Year
                  </label>
                  <input
                    className="govuk-input govuk-date-input__input govuk-input--width-4"
                    id="passport-issued-year"
                    name="passport-issued-year"
                    type="text"
                    inputMode="numeric"
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
};

export default DateRange;
